export default __webpack_public_path__ + "static/media/Programming1.6afdee22.png";